import { render } from "./StaffDatatableFormChairDoctors.vue?vue&type=template&id=596dea4c"
import script from "./StaffDatatableFormChairDoctors.vue?vue&type=script&lang=js"
export * from "./StaffDatatableFormChairDoctors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__